import {
    ICalendarEventUpdateMutationParameters,
    ICalendarEventUpdateMutationResult,
} from "./calendarEventUpdateMutation";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue } from "../../utils/filters";

export type ICalendarEventUpdateRecurrenciesMutationParameters = ICalendarEventUpdateMutationParameters;

export type ICalendarEventUpdateRecurrenciesMutationResult = ICalendarEventUpdateMutationResult;

export const calendarEventUpdateRecurrenciesMutation: IApiMutationFunction<
    ICalendarEventUpdateRecurrenciesMutationParameters
> = ({ calendarEvent, data }) => {
    const { brief, ...rest } = data;
    return {
        method: "PATCH",
        url: `/calendar-events/${mapRelationalValue(calendarEvent)}/recurrencies`,
        data: {
            ...rest,
            briefId: mapRelationalValue(brief),
        },
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
    };
};

export const useCalendarEventUpdateRecurrenciesMutation = createApiMutationHook<
    ICalendarEventUpdateRecurrenciesMutationParameters,
    ICalendarEventUpdateRecurrenciesMutationResult
>(calendarEventUpdateRecurrenciesMutation);
